<template>
  <div class="ui-segment-control" :class="[size, { 'width-auto': width === 'auto' }]">
    <button
      v-for="(option, index) in options"
      :key="index"
      class="segment-button"
      :class="{ active: modelValue === option.value }"
      @click="updateValue(option.value)"
      type="button"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    required: true,
  },
  options: {
    type: Array,
    required: true,
    validator: (value) => {
      return value.every((option) => "value" in option && "label" in option);
    },
  },
  // 'medium'(기본) | 'small' — 작은 변형(헤더 유저설정 팝오버 등)
  size: {
    type: String,
    default: "medium",
  },
  // 'fixed'(기본, max-width 131px 고정 — Y/N 2옵션 토글 전제) | 'auto'(옵션 개수에 맞춰 내용 폭)
  width: {
    type: String,
    default: "fixed",
    validator: (v) => ["fixed", "auto"].includes(v),
  },
});

const emit = defineEmits(["update:modelValue"]);

const updateValue = (value) => {
  emit("update:modelValue", value);
};
</script>
<style lang="scss" scoped>
@use "sass:color";

.ui-segment-control {
  display: inline-flex;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid $border-color;
  background-color: $background-color;
  width: 100%;
  max-width: 131px;
}

/* 작은 변형 */
.ui-segment-control.small {
  max-width: 104px;
}
.ui-segment-control.small .segment-button {
  padding: 4px 8px;
  font-size: 11px;
}

/* 폭 auto 변형 — 옵션 3개 이상 등 내용 폭이 131px 를 넘는 경우 (radius 유지 위해 overflow: hidden 은 유지) */
.ui-segment-control.width-auto {
  width: auto;
  max-width: none;
}
.ui-segment-control.width-auto .segment-button {
  flex: none;
}

.segment-button {
  padding: 8px 12px;
  border: none;
  cursor: pointer;
  background: transparent;
  font-size: $font-size-sm;
  transition: all $transition-normal ease;
  flex: 1;
  text-align: center;
  color: $text-color;
  position: relative;
  white-space: nowrap;
}

.segment-button.active {
  background-color: $primary-color;
  color: white;
  font-weight: 500;
}

.segment-button:hover:not(.active) {
  background-color: color.adjust(#f5f5f5, $lightness: -5%);
}

.segment-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba($primary-color, 0.2);
}
</style>
